import { IntegrationService } from '../../../../../../services/exports/Constants';

export default {
  title: 'Integraciones',
  services: {
    [IntegrationService.Tabless]: 'Tabless',
    [IntegrationService.WinOrder]: 'WinOrder',
    [IntegrationService.ExpertOrder]: 'ExpertOrder',
    [IntegrationService.Deliverect]: 'Deliverect',
    [IntegrationService.Liefersoft]: 'Liefersoft',
    [IntegrationService.Hubrise]: 'HubRise',
  },
  labels: {
    no_integrations: '{{company}} no tiene integraciones configuradas.',
  },
  buttons: {
    add_integration: 'Agregar integración',
  },
  toasts: {
    error: 'Error al guardar los cambios',
    success: 'Cambios guardados',
    load_error: 'Error al cargar las integraciones',
  },
};
